// src/pages/PublicCatalog/components/PhoneDialog.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    TextField,
    Button,
    Box
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    phoneDialog: {
        '& .MuiDialog-paper': {
            maxWidth: 400,
            width: '100%',
            margin: theme.spacing(2),
        },
    },
    phoneInputContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    countryCode: {
        width: '100px',
    },
    phoneInput: {
        flex: 1,
    },
    description: {
        marginTop: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
}));

const PhoneDialog = ({ 
    open, 
    onClose, 
    phoneNumber, 
    onPhoneChange,
    countryCode,
    onCountryCodeChange
}) => {
    const classes = useStyles();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (phoneNumber && countryCode) {
            onClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={classes.phoneDialog}
        >
            <DialogTitle>
                <Typography variant="h6">
                    Ingresa tu número de teléfono
                </Typography>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    <Typography variant="body2" className={classes.description}>
                        Necesitamos tu número de teléfono para enviarte los detalles de tu pedido por WhatsApp
                    </Typography>
                    <Box className={classes.phoneInputContainer}>
                        <TextField
                            label="Código"
                            value={countryCode}
                            onChange={(e) => onCountryCodeChange(e.target.value)}
                            className={classes.countryCode}
                            variant="outlined"
                            required
                            inputProps={{
                                maxLength: 4,
                                pattern: "[0-9]*"
                            }}
                            placeholder="505"
                        />
                        <TextField
                            label="Número de teléfono"
                            value={phoneNumber}
                            onChange={(e) => onPhoneChange(e.target.value)}
                            className={classes.phoneInput}
                            variant="outlined"
                            required
                            inputProps={{
                                maxLength: 12,
                                pattern: "[0-9]*"
                            }}
                            placeholder="12345678"
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        fullWidth
                        disabled={!phoneNumber || !countryCode}
                    >
                        Continuar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default PhoneDialog;